var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#FFC107"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.835 76.0909C112.835 83.6136 111.426 90.0568 108.608 95.4205C105.813 100.761 101.994 104.852 97.1534 107.693C92.3352 110.534 86.8693 111.955 80.7557 111.955C74.642 111.955 69.1648 110.534 64.3239 107.693C59.5057 104.83 55.6875 100.727 52.8693 95.3864C50.0739 90.0227 48.6761 83.5909 48.6761 76.0909C48.6761 68.5682 50.0739 62.1364 52.8693 56.7955C55.6875 51.4318 59.5057 47.3295 64.3239 44.4886C69.1648 41.6477 74.642 40.2273 80.7557 40.2273C86.8693 40.2273 92.3352 41.6477 97.1534 44.4886C101.994 47.3295 105.813 51.4318 108.608 56.7955C111.426 62.1364 112.835 68.5682 112.835 76.0909ZM100.119 76.0909C100.119 70.7955 99.2898 66.3295 97.6307 62.6932C95.9943 59.0341 93.7216 56.2727 90.8125 54.4091C87.9034 52.5227 84.5511 51.5795 80.7557 51.5795C76.9602 51.5795 73.608 52.5227 70.6989 54.4091C67.7898 56.2727 65.5057 59.0341 63.8466 62.6932C62.2102 66.3295 61.392 70.7955 61.392 76.0909C61.392 81.3864 62.2102 85.8636 63.8466 89.5227C65.5057 93.1591 67.7898 95.9205 70.6989 97.8068C73.608 99.6705 76.9602 100.602 80.7557 100.602C84.5511 100.602 87.9034 99.6705 90.8125 97.8068C93.7216 95.9205 95.9943 93.1591 97.6307 89.5227C99.2898 85.8636 100.119 81.3864 100.119 76.0909ZM118.631 51.7841V41.1818H174.335V51.7841H152.756V111H140.21V51.7841H118.631ZM185.074 111V41.1818H229.801V51.7841H197.722V70.7386H226.733V81.3409H197.722V111H185.074Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.52 402.335V261.71H132.832V235.668H268.249V261.71H213.561V402.335H187.52ZM281.27 402.335V313.793H247.415V287.751H341.165V313.793H307.311V402.335H281.27Z",
    fill: "#FFC107"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_541",
    x: 36.6758,
    y: 40.2266,
    width: 197.125,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_541"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_541",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtf);
export default __webpack_public_path__ + "static/media/otf.4c282886f551ecea740ea8a615f62002.svg";
export { ForwardRef as ReactComponent };